import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import * as React from "react";
import { CreateNewOptionDropdownItem } from "../styles";
export var CreateNewOptionButton = function(param) {
    var createNewOption = param.createNewOption, searchValue = param.searchValue, filteredOptions = param.filteredOptions, highlightIndex = param.highlightIndex, onHighlight = param.onHighlight, closeDropdown = param.closeDropdown, resetSearchValue = param.resetSearchValue, refs = param.refs;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var handleClick = React.useCallback(function() {
        var _createNewOption_onClick;
        if (createNewOption === null || createNewOption === void 0 ? void 0 : createNewOption.closeDropdown) {
            closeDropdown();
        }
        if (createNewOption === null || createNewOption === void 0 ? void 0 : createNewOption.hideUnlessNoOptions) {
            resetSearchValue();
        }
        createNewOption === null || createNewOption === void 0 ? void 0 : (_createNewOption_onClick = createNewOption.onClick) === null || _createNewOption_onClick === void 0 ? void 0 : _createNewOption_onClick.call(createNewOption, searchValue);
    }, [
        createNewOption,
        closeDropdown,
        resetSearchValue,
        searchValue
    ]);
    if (!createNewOption) {
        return null;
    }
    if (createNewOption.hideUnlessNoOptions && (!searchValue || filteredOptions.some(function(option) {
        return option.label.toLocaleLowerCase() === searchValue.toLocaleLowerCase().trim();
    }))) {
        return null;
    }
    var index = filteredOptions.length + 1;
    var createNewOptionLabel = typeof createNewOption.label === "function" ? createNewOption.label(searchValue) : createNewOption.label;
    return /*#__PURE__*/ _jsx(CreateNewOptionDropdownItem, {
        role: "option",
        tabIndex: -1,
        onClick: handleClick,
        "data-test-id": "dropdownItem_CustomizedOption",
        type: "button",
        ref: function(el) {
            if (!el) {
                return;
            }
            refs.current[index] = el;
        },
        onMouseOver: function() {
            return onHighlight(index);
        },
        $highlight: index === highlightIndex,
        children: /*#__PURE__*/ _jsxs(Row, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(Add, {
                    color: Core.icon.default,
                    height: getSpacing("2x"),
                    width: getSpacing("2x"),
                    "aria-label": strictLocalize({
                        id: "G/HAOV",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Add new option value"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                createNewOptionLabel
            ]
        })
    }, "dropdownItem_CustomizedOption");
};
